import api from './api';

export const concessions = {
  // Récupérer toutes les concessions (super-admin)
  getAll: () => api.get('/concessions'),
  
  // Récupérer ma concession
  getMy: () => api.get('/concessions/my'),
  
  // Créer une concession (super-admin)
  create: (data) => api.post('/concessions', data),
  
  // Modifier une concession (super-admin)
  update: (id, data) => api.put(`/concessions/${id}`, data),
  
  // Désactiver une concession (super-admin)
  delete: (id) => api.delete(`/concessions/${id}`),
  
  // Statistiques d'une concession (super-admin)
  getStats: (id) => api.get(`/concessions/${id}/stats`)
};

export default concessions;
